// This service loads labels from the api, the labels are defined in labels.json on the server.
//
// constants.json
// "area": {
//   "languages": {
//     "nl": {
//       "label": "ruimte",
//         "plural": "ruimten"
//     },
//     "en": {
//       "label": "area",
//         "plural": "areas"
//     }
//   }
// },
//  .....
//
// If you want the label of keyword "area" in dutch, you can call:
//
//      Labels.getLabel('area', 'nl');
//
// When the language argument is not set: dutch is the default language

(function () {

  'use strict';

  angular
    .module('specsguardApp')
    .service('Labels', labelsService);

  labelsService.$inject = ['Auth', 'LABELS_CONSTANT', 'sgTranslateHelpers'];

  function labelsService (Auth, LABELS_CONSTANT, sgTranslateHelpers) {
    let labels = LABELS_CONSTANT;
    let TranslateHelpers = new sgTranslateHelpers({
      labels,
      languageFn: Auth.getCurrentUserLanguage
    });

    function getLanguages () {
      return Promise.resolve(labels);
    }

    function translateMenuData (menuData) {
      const lang = Auth.getCurrentUserLanguage();

      Object.keys(menuData).forEach((menuType) => {
        menuData[menuType].forEach((menuItem) => {
          const userLang = menuItem.languages && menuItem.languages[lang];
          menuItem.title = userLang ? userLang.title : menuItem.title;

          if (menuItem.addButton) {
            menuItem.addButton.title = userLang ? userLang.addButton : menuItem.addButton.title;
          }
        });
      });

      return menuData;
    }

    function getAll () {
      return labels;
    }

    return {
      getLanguages: getLanguages,
      getAll: getAll,
      translateMenuData,
      getLabel: TranslateHelpers.getLabel.bind(TranslateHelpers),
      getLabelPlaceholder: TranslateHelpers.getLabelPlaceholder.bind(TranslateHelpers),
      getLabelPlaceholderLowerCase: TranslateHelpers.getLabelPlaceholderLowerCase.bind(TranslateHelpers),
      getLabelTextWithPlaceholder: TranslateHelpers.getLabelTextWithPlaceholder.bind(TranslateHelpers),
      getLabelLowerCase: TranslateHelpers.getLabelLowerCase.bind(TranslateHelpers),
      getLabelUpperCase: TranslateHelpers.getLabelUpperCase.bind(TranslateHelpers),
      getLabelCapFirstLetter: TranslateHelpers.getLabelCapFirstLetter.bind(TranslateHelpers),
      getPlural: TranslateHelpers.getPlural.bind(TranslateHelpers),
      getPluralLowerCase: TranslateHelpers.getPluralLowerCase.bind(TranslateHelpers),
      getPluralUpperCase: TranslateHelpers.getPluralUpperCase.bind(TranslateHelpers),
      getPluralCapFirstLetter: TranslateHelpers.getPluralCapFirstLetter.bind(TranslateHelpers),
    };
  }

})();
